/**
 * API Configuration for Appeal Your Home Frontend
 */

// Get API base URL from environment variables or fallback to appropriate default
const getApiBaseUrl = () => {
  // Use build-time environment variable if provided
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }
  
  // In development, use API gateway (nginx proxy)
  if (import.meta.env.DEV) {
    return 'http://localhost:8080/api';
  }
  
  // In production, use the Appeal Your Home API
  return 'https://api.appealyourhome.com/api';
};

export const API_CONFIG = {
  baseURL: getApiBaseUrl(),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
};

// API endpoints
export const API_ENDPOINTS = {
  // Auth
  auth: {
    register: '/auth/register',
    login: '/auth/login',
    refresh: '/auth/refresh',
    logout: '/auth/logout',
    resetPassword: '/auth/reset-password',
    verifyEmail: '/auth/verify-email',
    googleOAuth: '/auth/google',
    googleOAuthStatus: '/auth/google/status',
    googleOAuthCallback: '/auth/google/callback',
  },
  
  // Users
  users: {
    profile: '/users/profile',
    properties: '/users/properties',
    progress: '/users/progress',
  },
  
  // Courses
  courses: {
    modules: '/courses/modules',
    resources: '/courses/resources',
    complete: '/courses/modules/:id/complete',
  },
  
  // Properties
  properties: {
    validateAddress: '/properties/validate-address',
    classify: '/properties/classify',
    counties: '/properties/counties',
  },
  
  // Integration
  integration: {
    aiGenerate: '/integration/ai/generate',
    aiStatus: '/integration/ai/status',
    payment: '/integration/payment/checkout',
    webhook: '/integration/payment/webhook',
  },
};

// Helper function to build full URL
export const buildApiUrl = (endpoint) => {
  return `${API_CONFIG.baseURL}${endpoint}`;
}; 